import { observable, action, computed, reaction } from 'mobx'
import { Merchant, createStub } from '../Model/MerchantModel'
import ActionsLocalService from '../Services/ActionsLocalService'
import { ExportType } from './ExportStore'

export default class MerchantsStore {

    @observable
    private item: Merchant | null

    @observable
    private list: Array<Merchant>

    private static _instance: MerchantsStore

    private constructor() {
        this.list = []

        reaction(
            () => this.list,
            _ => {
                let data = createStub(this.list)
                ActionsLocalService.getInstance().setExportData(ExportType.Merchants, data)
            }
        )
    }

    public static getInstance(): MerchantsStore {
        return this._instance || (this._instance = new this())
    }

    @action.bound
    setList(list: Array<Merchant>): void {
        this.list = list
    }

    @computed
    get getList(): Array<Merchant> {
        return this.list
    }

    @action.bound
    setItem(item: Merchant | null) {
        this.item = item
    }

    @computed
    get getItem(): Merchant | null {
        return this.item
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/MerchantsStore.ts